"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGDD = exports.editGeneralInfo = exports.createGDD = exports.initialState = void 0;
var gddTypes_1 = require("@_types/gddTypes");
var toolkit_1 = require("@reduxjs/toolkit");
exports.initialState = {
    gdd: {
        id: "",
        title: "",
        genre: "",
        view: gddTypes_1.GameView.FirstPerson, // Visual style of the game (e.g., 2D, 3D)
        platform: gddTypes_1.GamePlatform.PC, // Platforms the game is targeting (e.g., PC, Mobile)
    },
};
var gddSlice = (0, toolkit_1.createSlice)({
    name: "gdd",
    initialState: exports.initialState,
    reducers: {
        createGDD: function (state, action) {
            state.gdd = action.payload;
        },
        editGeneralInfo: function (state, action) {
            state.gdd = __assign(__assign({}, state.gdd), { title: action.payload.title, genre: action.payload.genre, view: action.payload.view, platform: action.payload.platform });
        },
        closeGDD: function () {
            return exports.initialState;
        },
    },
});
exports.createGDD = (_a = gddSlice.actions, _a.createGDD), exports.editGeneralInfo = _a.editGeneralInfo, exports.closeGDD = _a.closeGDD;
exports.default = gddSlice.reducer;
